import { useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useAuthStore } from '../stores/authStore';

export function useAuth() {
  const { user, supabaseUser, isLoading, setUser, logout } = useAuthStore();

  useEffect(() => {
    // Initial check
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        // Here we ideally fetch /api/auth/me to get the AppUser
        // For now, we set a dummy AppUser with the session email
        setUser({
          id: session.user.id,
          email: session.user.email!,
          role: 'admin',
        }, session.user);
      } else {
        setUser(null, null);
      }
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        setUser({
          id: session.user.id,
          email: session.user.email!,
          role: 'admin',
        }, session.user);
      } else {
        setUser(null, null);
      }
    });

    return () => subscription.unsubscribe();
  }, [setUser]);

  return { user, supabaseUser, isLoading, logout };
}
